export type HoraTipo = 'PAD' | 'ADI' | 'PLA' | 'ACI';

export const HORA_TIPOS: ReadonlyArray<{ value: HoraTipo; label: string }> = [
  { value: 'PAD', label: 'Padrão' },
  { value: 'ADI', label: 'Adicional' },
  { value: 'PLA', label: 'Plantão' },
  { value: 'ACI', label: 'Acionamento' },
];

export interface TipoHoraDto {
  id: number;
  nome: string;
  sigla: string;
  multiplicadorHora: number;
  tipo: HoraTipo;
  ativo: boolean;
  excluidoEm: string | null;
  excluidoPorGuid: string | null;
  excluidoPorNome: string | null;
  criadoEm: string;
  criadoPorGuid: string;
  criadoPorNome: string;
  atualizadoEm: string | null;
  atualizadoPorGuid: string | null;
  atualizadoPorNome: string;
}

export interface TipoHoraListItem {
  id: number;
  nome: string;
  sigla: string;
  multiplicadorHora: number;
  tipo: HoraTipo;
  ativo: boolean;
}

export interface TipoHoraInput {
  nome: string;
  sigla: string;
  multiplicadorHora: number;
  tipo: HoraTipo;
  ativo?: boolean;
}
